module.exports = __webpack_public_path__ + "static/media/MY-UTP.7eb097f6.png";